import PropTypes from "prop-types";
import { useMemo } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";

// project-imports
import DrawerHeader from "./DrawerHeader";
import DrawerContent from "./DrawerContent";
import MiniDrawerStyled from "./MiniDrawerStyled";

import { DRAWER_WIDTH } from "config";
import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import { useSelector } from "react-redux";
import { canAccessAdminPanel } from "utils/adminAccess";

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

export default function MainDrawer({ window }) {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  const user = useSelector((state) => state.auth.user);

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // responsive drawer container
  const container =
    window !== undefined ? () => window().document.body : undefined;

  // header content
  const drawerContent = useMemo(() => <DrawerContent />, []);
  const drawerHeader = useMemo(
    () => <DrawerHeader open={drawerOpen} />,
    [drawerOpen],
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { md: 0 }, zIndex: 1200 }}
      aria-label="mailbox folders"
    >
      {!downLG ? (
        <MiniDrawerStyled
          variant="permanent"
          open={drawerOpen}
          isAdmin={canAccessAdminPanel(user)}
        >
          {drawerHeader}
          {drawerContent}
        </MiniDrawerStyled>
      ) : (
        <>
          <Drawer
            container={container}
            variant="temporary"
            open={drawerOpen}
            onClose={() => handlerDrawerOpen(!drawerOpen)}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", lg: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: DRAWER_WIDTH,
                borderRight: `1px solid ${theme.palette.divider}`,
                // background: `
                // url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 1200'%3E%3Cpath d='M 280,80 C 360,90 420,150 410,280 C 400,410 340,480 260,450 C 180,420 150,320 170,190 C 190,60 240,70 280,80 Z' fill='%230049e008'/%3E%3Cpath d='M -20,250 C 80,230 180,280 200,440 C 220,600 150,720 50,690 C -50,660 -80,520 -60,360 C -40,200 -60,265 -20,250 Z' fill='%230049e00a'/%3E%3Cpath d='M 220,550 C 320,530 420,610 440,780 C 460,950 380,1020 280,980 C 180,940 140,820 160,650 C 180,480 200,565 220,550 Z' fill='%230049e006'/%3E%3Cpath d='M 300,950 C 380,960 440,1020 430,1120 C 420,1220 360,1260 280,1240 C 200,1220 170,1140 190,1040 C 210,940 260,945 300,950 Z' fill='%230049e007'/%3E%3Cpath d='M 50,850 C 120,830 190,870 210,970 C 230,1070 180,1150 110,1130 C 40,1110 10,1030 30,930 C 50,830 30,860 50,850 Z' fill='%230049e005'/%3E%3C/svg%3E"),
                // linear-gradient(180deg, #ffffff 0%, #f5f9ff 100%)
                // `,
                // backgroundSize: "100% 100%, 100% 100%",
                top: 0,
              },
            }}
          >
            {drawerHeader}
            {drawerContent}
          </Drawer>
        </>
      )}
    </Box>
  );
}

MainDrawer.propTypes = { window: PropTypes.func };
